export default {
  data() {
    return {
      errors: {}
    };
  },
  methods: {
    fieldHasError(field) {
      return this.errors[field] !== undefined;
    },
    getFieldError(field) {
      return this.errors[field] ? this.errors[field][0] : "";
    },
    handleFormError(error) {
      switch (error.response.status) {
        case 422:
          this.errors = error.response.data;
          break;
        case 413:
          this.$bvToast.toast("The maximum allowed file size is 25M", {
            variant: "warning"
          });
          break;
      }
      throw error;
    },
    clearErrors() {
      this.errors = {};
    }
  }
};
